import { AnalyticsBrowser } from '@segment/analytics-next'

const writeKey = process.env.SEGMENT_WRITEKEY;

export const analytics = writeKey ? AnalyticsBrowser.load({ writeKey }) : null;